// =============================
// Imports
// =============================

// External Dependencies
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { NextSeo } from 'next-seo';
import { withRouter } from 'next/router';
import _isEqual from 'lodash/isEqual';
import _pick from 'lodash/pick';

// Config
import { withTranslation } from '../config/i18n';

// Actions
import storeWrapper from '../store';
import {
  getEntitySearchData as getEntitySearchDataBase,
  resetEntitySearchData as resetEntitySearchDataBase,
} from '../store/actions/SearchActions';

// Components
import PrivateRoute from '../components/containers/privateRoute';
import EntitySearch from '../components/layouts/entitysearch';

// Helpers
import * as pth from '../helpers/proptypes';
import { getWebsiteTitle } from '../helpers/misc';

// =============================
// Page
// =============================

class EntitySearchPage extends PureComponent {
  static propTypes = {
    config: pth.config.isRequired,
    results: PropTypes.arrayOf(pth.entitysearchdoc).isRequired,
    getResults: PropTypes.func.isRequired,
    resetResults: PropTypes.func.isRequired,
    query: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    page: PropTypes.number.isRequired,
    nbPages: PropTypes.number.isRequired,
    t: PropTypes.func.isRequired,
  };

  static getInitialProps = storeWrapper
    .getInitialPageProps(store => async ({ query: routerQuery }) => {
      const { page = 0, query = '', type = 'albums' } = routerQuery;

      await store.dispatch(getEntitySearchDataBase(type, parseInt(page, 10), query));

      return {
        query,
        type,
        namespacesRequired: ['common', 'pages', 'components', 'errors'],
      };
    });

  componentDidUpdate(prevProps) {
    const { router: { route: prevRoute, query: prevQuery } } = prevProps;
    const { router: { route, query: nextQuery }, getResults } = this.props;

    const queryParams = ['page', 'query', 'type'];

    if (
      prevRoute === route
      && route === '/entitysearch'
      && !_isEqual(_pick(prevQuery, queryParams), _pick(nextQuery, queryParams))
    ) {
      getResults(nextQuery.type, parseInt(nextQuery.page || 0, 10), nextQuery.query || '');
    }
  }

  componentWillUnmount() {
    const { resetResults } = this.props;

    resetResults();
  }

  render() {
    const { config, results, t, ...restProps } = this.props;

    return (
      <PrivateRoute>
        <NextSeo
          title={getWebsiteTitle(config, t('pages:search.meta_title'))}
          noindex
        />
        <EntitySearch
          config={config}
          results={results}
          t={t}
          {...restProps}
        />
      </PrivateRoute>
    );
  }
}

function mapStateToProps({ search }) {
  return {
    results: search.entitySearch.data,
    total: search.entitySearch.total,
    page: search.entitySearch.page,
    nbPages: search.entitySearch.nbPages,
  };
}

export default compose(
  withTranslation('pages'),
  connect(mapStateToProps, {
    getResults: getEntitySearchDataBase,
    resetResults: resetEntitySearchDataBase,
  }),
  withRouter,
)(EntitySearchPage);
